import Base from './base';
import { IUserLoginRequest, IUserRegisterRequest, IUserUpdateRequest } from '../../interfaces/models/user';

export default {
  login: async (data: IUserLoginRequest): Promise<any> => (await Base()).post('/users/login', data),
  signup: async (data: IUserRegisterRequest): Promise<any> => (await Base()).post('/users/signup', data),
  update: async (data: IUserUpdateRequest): Promise<any> => (await Base()).put('/users/', data),
  current: async (): Promise<any> => (await Base()).get('/users/'),
};
